export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SET_OPTION_LIST = 'SET_OPTION_LIST';
export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM';
export const SET_OPTION_FORM_LIST = 'SET_OPTION_FORM_LIST';
export const SET_OPTION_CODE_LIST = 'SET_OPTION_CODE_LIST';
export const SET_UNMANAGED_TABLE_LIST = 'SET_UNMANAGED_TABLE_LIST';
export const SET_SCHEMA_LIST = 'SET_SCHEMA_LIST';
export const SET_OPTION_PLANT_LIST = 'SET_OPTION_PLANT_LIST';
export const SET_TABLE_MANAGEMENT_MODAL_VALUE = 'SET_TABLE_MANAGEMENT_MODAL_VALUE';

export default {
	DEFAULT_ASSIGN,
	SET_OPTION_LIST,
	SET_OPTION_PLANT_LIST,
	SET_SEARCH_PARAM,
	SET_OPTION_FORM_LIST,
	SET_OPTION_CODE_LIST,
	SET_UNMANAGED_TABLE_LIST,
	SET_SCHEMA_LIST,
	SET_TABLE_MANAGEMENT_MODAL_VALUE
};
